import React from 'react';

const AJAX_XML_File = () => {
  return (
    <div >
      <h1>AJAX_XML_File</h1>
      <p>Placeholder component for: "AJAX XML File"</p>
    </div>
  );
};

export default AJAX_XML_File;
